module.exports = __webpack_public_path__ + "img/MunsterSmall.9a2a7a89.png";